<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab :key="1" ripple active-class="tab">{{ $t("seasonalPage.reservationTab") }}</v-tab>
      <v-tab-item>
        <div>
          <v-data-table
            :headers="headers"
            :items="reservation"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :loading="loading"
            :pagination.sync="pagination"
            :hide-default-footer="true"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  <span style="display: grid; width: 100px; max-width: 100px;">{{ $t('seasonalPage.timeRange', { from: props.item.time, to: props.item.To }) }}</span>
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                    type="number"
                    v-model="props.item.Mon"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Tue"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Wed"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Thu"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Fri"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Sat"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Sun"
                  />
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr>
                <td colspan="8" class="text-xs-end">
                  <v-btn
                  :loading="loading"
                    color="primary"
                    v-if="reservation"
                    @click="updateData('Reservation')"
                    >{{ $t("seasonalPage.updateAll") }}</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-tab-item>
      <v-tab :key="2" ripple active-class="tab">{{ $t("seasonalPage.shortReservationTab") }}</v-tab>
      <v-tab-item>
        <div>
          <v-data-table
            :headers="headers"
            :items="shortReservation"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :loading="loading"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  <span style="display: grid; width: 100px; max-width: 100px;">{{ $t('seasonalPage.timeRange', { from: props.item.time, to: props.item.To }) }}</span>
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Mon"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                    v-model="props.item.Tue"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Wed"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                    type="number"
                    v-model="props.item.Thu"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Fri"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                  style="text-align: center"
                  type="number"
                  v-model="props.item.Sat"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Sun"
                  />
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr>
                <td colspan="8" class="text-xs-end">
                  <v-btn
                  :loading="loading"
                    color="primary"
                    v-if="reservation"
                    @click="updateData('ShortReservation')"
                    >{{ $t("seasonalPage.updateAll") }}</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
    </v-tab-item>
      <v-tab :key="3" ripple active-class="tab" v-if="false">{{ $t("seasonalPage.instantTab") }}</v-tab>
      <v-tab-item v-if="false">
        <div>
          <v-data-table
            :headers="headers"
            :items="instant"
            :rows-per-page-items="pagination.rowsPerPageItems"
            :loading="loading"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">
                  <span style="display: grid; width: 100px; max-width: 100px;">{{ $t('seasonalPage.timeRange', { from: props.item.time, to: props.item.To }) }}</span>
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Sun"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Mon"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Tue"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Wed"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Thu"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Fri"
                  />
                </td>
                <td class="text-xs-center">
                  <input
                  min="0"
                    style="text-align: center"
                    type="number"
                    v-model="props.item.Sat"
                  />
                </td>
              </tr>
            </template>
            <template v-slot:footer>
              <tr>
                <td colspan="8" class="text-xs-end">
                  <v-btn
                  :loading="loading"
                    color="primary"
                    v-if="reservation"
                    @click="updateData('instant')"
                    >{{ $t("seasonalPage.updateAll") }}</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
    </v-tab-item>
    </v-tabs>
  </div>
</template>
      
    <script>
import DataTable from "@/components/monaco/DataTable";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";
import moment from "moment";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "Statistics",
  components: {
    DataTable,
    ChooseDate,
    DatePickerMultiple,
    VueTagsInput,
  },
  data() {
    return {
      reservation: [],
      shortReservation: [],
      instant: [],
      data: [],
      perPage: 100,
      loading: false,
      pagination: {
        rowsPerPage: 100,
        rowsPerPageItems: [5, 10, 15, 25, 100],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("perPage", this.perPage);
      this.axios
        .get("max_booking_counts", {
          params: params,
        })
        .then((res) => {
          console.log("data");
          console.log(res.data.data);
          this.data = res.data.data;
          var reservation = [];
          var shortReservation = [];
          var instant = [];
          res.data.data.forEach(function (item, index) {
            const {
              day,
              time,
              max_reservation,
              max_short_reservation,
              max_instant,
            } = item;
            const entry = {
              id: index + 1,
              time,
              [day]: max_reservation.toString(),
            };
            const shortEntry = {
              id: index + 1,
              time,
              [day]: max_short_reservation.toString(),
            };
            const [hours, minutes] = time.split(":");
            const date = new Date();
            date.setHours(parseInt(hours, 10));
            date.setMinutes(parseInt(minutes, 10));
            date.setHours(date.getHours() + 1);

            const newTime = `${String(date.getHours()).padStart(
              2,
              "0"
            )}:${String(date.getMinutes()).padStart(2, "0")}`;
            // Check if the time already exists in the reservation array
            const existingTimeIndex = reservation.findIndex(
              (entry) => entry.time === time
            );
            if (existingTimeIndex !== -1) {
              // If the time already exists, update the existing entry with the day and max_reservation values
              reservation[existingTimeIndex][day] = max_reservation.toString();
              reservation[existingTimeIndex].To = newTime;
            } else {
              // If the time doesn't exist, create a new entry with the time, day, and max_reservation values
              const newEntry = { time };
              newEntry[day] = max_reservation.toString();
              newEntry.To = newTime;
              reservation.push(newEntry);
            }

            // Check if the time already exists in the shortReservation array
            const existingShortTimeIndex = shortReservation.findIndex(
              (entry) => entry.time === time
            );
            if (existingShortTimeIndex !== -1) {
              // If the time already exists, update the existing entry with the day and max_short_reservation values
              shortReservation[existingShortTimeIndex][day] =
                max_short_reservation.toString();
              shortReservation[existingShortTimeIndex].To = newTime;
            } else {
              // If the time doesn't exist, create a new entry with the time, day, and max_short_reservation values
              const newShortEntry = { time };
              newShortEntry[day] = max_short_reservation.toString();
              newShortEntry.To = newTime;
              shortReservation.push(newShortEntry);
            }

            // Check if the time already exists in the shortReservation array
            const existingInstantTimeIndex = instant.findIndex(
              (entry) => entry.time === time
            );
            if (existingInstantTimeIndex !== -1) {
              // If the time already exists, update the existing entry with the day and max_short_reservation values
              instant[existingInstantTimeIndex][day] =
                max_instant.toString();
                instant[existingInstantTimeIndex].To = newTime;
            } else {
              // If the time doesn't exist, create a new entry with the time, day, and max_short_reservation values
              const newInstantEntry = { time };
              newInstantEntry[day] = max_instant.toString();
              newInstantEntry.To = newTime;
              instant.push(newInstantEntry);
            }
          });
        //   console.log("reservation");
        //   console.log(reservation);
        //   console.log("shortReservation");
        //   console.log(shortReservation);
        //   console.log("instant");
        //   console.log(instant);
          this.reservation = reservation;
          this.shortReservation = shortReservation;
          this.instant = instant;
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
    updateData(type) {
      console.log("updateReservation");
      console.log(this.reservation);
      this.loading = true;
      const requestData = {
            data: type == "Reservation" ? this.reservation : this.shortReservation,
            _method: "PUT",
        };
      this.axios
        .post(`max_booking_counts/${type}`, requestData)
        .then((res) => {
            this.loading = false;
            window.getApp.$emit("SHOW_TOAST", this.$t("seasonalPage.updatedToast"));
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
  },
  watch: {},
  computed: {
    headers() {
      return [
        { text: this.$t("seasonalPage.colTime"), value: "time", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colMon"), value: "Mon", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colTue"), value: "Tue", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colWed"), value: "Wed", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colThu"), value: "Thu", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colFri"), value: "Fri", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colSat"), value: "Sat", sortable: false, align: "center" },
        { text: this.$t("seasonalPage.colSun"), value: "Sun", sortable: false, align: "center" },
      ];
    },
  },
  formatter() {
    return {
      active(val) {
        //language=HTML
        return `
                        <i class="v-icon fa ${
                          val ? "fa-check" : "fa-close"
                        }"></i>
                        `;
      },
    };
  },
};
</script>
  <style lang="scss" scoped>
.options {
  width: 100%;
  float: inline-start;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;
  // gap: 16px;
  .option {
    float: inline-start;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;
    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: inline-start;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }
    .percentage {
      width: 100%;
      padding: 0 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-inline-start: 4px;
      }
    }
  }
}
.vue-tags-input {
  background: #324652;
  width: 100%;
  max-width: none !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent;
  width: 100%;
  color: #b7c4c9;
}

.vue-tags-input .ti-input {
  background: #fafafa;
  padding: 14px 10px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid black;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ff5252;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #283944;
  border: 1px solid #8b9396;
  border-top: none;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item.ti-selected-item {
  background: #ebde6e;
  color: #283944;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative;
  background: #ebde6e;
  color: #283944;
  overflow: hidden;
}

/* we defined a custom css class in the data model, now we are using it to style the tag */
.vue-tags-input .ti-tag.custom-class {
  background: transparent;
  border: 1px solid #ebde6e;
  color: #ebde6e;
  margin-inline-end: 4px;
  border-radius: 0px;
  font-size: 13px;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  inset-inline-start: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}
.tab {
  color: #e21024 !important;
}
.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

body {
  font-family: system-ui;
}

table,
th {
  border: 1px solid black;
  border-collapse: collapse;
}

td {
  text-align: center;
}

.bordered {
  border: 1px solid black;
  border-collapse: collapse;
}

.half-bordered {
  border-inline-start: 1px solid black;
  border-inline-end: 1px solid black;
  border-collapse: collapse;
}

.column {
  float: inline-start;
  width: 50%;
  box-sizing: border-box;
}

.column1 {
  float: inline-start;
  width: 30%;
  box-sizing: border-box;
}

.column2 {
  float: inline-start;
  width: 35%;
  box-sizing: border-box;
}
.column3 {
  float: inline-start;
  width: 35%;
  box-sizing: border-box;
}

.row:after {
  content: "";
  display: table;
  clear: both;
  box-sizing: border-box;
  width: 100%;
  padding-top: 10px;
}
</style>
    